import styled from 'styled-components';
import RSelect, { components } from 'react-select';
import AsyncRSelect from 'react-select/async';

import { FormLabel as Label } from '~ui-kit';
import Error from '../../forms/formik/components/Error';
import { errorColor, textGrey, detailGrey } from '~theme';

// eslint-disable-next-line react/display-name
const noOptionsMessageWrapper = label => props =>
  (
    <components.NoOptionsMessage {...props}>
      {label || 'Ei hakutuloksia'}
    </components.NoOptionsMessage>
  );

const Select = ({
  label,
  error,
  required,
  noOptionsMessage,
  info,
  noErrorLabel,
  flat,
  labelWidth,
  disabled,
  components,
  styles,
  className,
  instruction,
  options,
  ...props
}) => {
  const localProps = {
    isDisabled: disabled,

    // Add instruction as disabled option if specified
    isOptionDisabled: option => option.id === 'instruction',
    options: instruction
      ? [{ id: 'instruction', label: instruction }, ...options]
      : options,

    components: {
      NoOptionsMessage: noOptionsMessageWrapper(noOptionsMessage),
      ...components,
    },
    ...props,
    placeholder: props.placeholder || 'Valitse...',
    styles: {
      control: styles => ({
        ...styles,
        minHeight: '42px',
        borderColor: error ? errorColor : styles.borderColor,
        fontSize: '16px',
      }),
      singleValue: styles => ({
        ...styles,
        height: '100%',
        alignItems: 'center',
        display: 'flex',
      }),
      menu: styles => ({
        ...styles,
        color: textGrey,
        fontSize: '16px',
      }),
      option: (styles, state) => ({
        ...styles,
        // Info text style
        color: state.isDisabled ? detailGrey : textGrey,
        fontSize: state.isDisabled ? '14px' : 'initial',
      }),
      ...styles,
    },
  };

  return (
    <Container flat={flat} className={className}>
      {label && (
        <Label
          noMargin={flat}
          required={required}
          htmlFor={name}
          info={info}
          width={labelWidth}
        >
          {label}
        </Label>
      )}
      {props.async ? (
        <AsyncRSelect {...localProps} />
      ) : (
        <RSelect {...localProps} />
      )}
      {error && !noErrorLabel ? <Error>{error}</Error> : null}
    </Container>
  );
};

const Container = styled.div`
  ${props =>
    props.flat &&
    `
  display: flex;
  align-items: center;
  gap: 12px;

  & > div {
    min-width: 0px;
    flex-grow: 1;
  }

  #dropdown {
    flex: 1;
    flex-shrink: 1;
  }
  `}
`;

export default Select;
